import React from "react";
import './standard-classwork-experience.scss';
// import SharedProfile from "../../../../shared-storage/profile";
import CommonUtils from "../../../utility/common-utilities";
import HomeworkApi from "../../../apis/homework";
// import AssessmentHeader from "../../common/assessment-header/assessment-header";
import Question from "../question/question";
import SuccessFailureScreen from '../practice-end-screen/practice-end-screen'
// import ConceptList from "../my-classwork-V1/classwork-concept-list-screen/classwork-concept-list";
// import HomeworkConceptList from '../my-homework/classwork-concept-list-screen/classwork-concept-list';
import { Constants } from "../../../constants/constants";
// import FireBaseEvent from '../../firebase-events/firebase-events';
import LayoutShared from "../../common/layout-shared/layout-shared";
import Loading from "../../common/loading/loading";
import HomeworkForClickerPracticeApi from "../../../apis/homework-for-clicker-practice";


export const ClickerPracticeConText = React.createContext({ disableNext: false, index: 0 })


export default class WorkflowExperience extends React.Component {

    workflowEngine = null;
    worflowNodes = [];
    questions = [];
    assessedResponse = {};
    multiStepTimeListHash = {}
    state = {
        questions: [],
        studentList: this.props.studentList,
        answers: [],
        learningElos: [],
        showSuccessFailureScreen: false,
        stepIndex: 0,
        showHint: false,
        showSolvedExamplesModal: false,
        showInvalidAnswerModal: false,
        showCorrectIncorrectModal: false,
        showCorrectAnswer: false,
        isReadOnly: false,
        disableNext: false,
        toastText: "",
        questionLoading: true,
        currentQuestionNumber: 0,
        currentIndex: 0, // Introduced this key to keep track of current Index when we go previous and comeback to stop there
        showPreviousQuestion: false,
        showMainQuestion: true,
        isResume: false
    };
    questionComponent = null;
    successFailureScreenData = {
    };

    params = {

    }

    isRevise = false;

    isCorrect = false;
    eloIds = []

    constructor(props) {
        super(props);

        this.params = this.props.params
        this.layoutShared = LayoutShared.getLayout()

        console.log(this.params, 'online')
    }

    componentDidMount() {


        if (this.params.status != 'ASSIGNED') {
            this.toggleLayoutBar()
        }

        this.getAssessmentContent((err, data) => {
            if (err) {
                return;
            }

            this.setQuestion(data);
        });

        // if (!this.userInfo.isSubscribed) {
        //     this.showTimerPauseToast()

        //     this.props.navigation.addListener("didFocus", () => {
        //         AppState.addEventListener('change', this._handleAppStateChange);
        //     });

        //     this.props.navigation.addListener("didBlur", () => {
        //         AppState.removeEventListener('change', this._handleAppStateChange);
        //     });

        // }

        // BackHandler.addEventListener('hardwareBackPress', this.backhandler);
        this.setZoomOut()

        if (window.AndroidClicker) {
            this.startScanning()
            this.callInInterval()

            if (window.AndroidClicker && window.AndroidClicker.getBluetoothStatus) {
                this.intervalForBLE = setInterval(() => {
                    this.checkBLEStatus()
                }, 0.5 * 60 * 1000);
            }

        }

    }

    checkBLEStatus() {
        const statusJson = window.AndroidClicker.getBluetoothStatus();
        const status = JSON.parse(statusJson);
        //console.log("Bluetooth status:", status);

        // Example: show on UI
        if (!status.receivingSignal) {
            // alert("Bluetooth not receiving signal!");
            //console.log('No Bluetooth Signal received.........')
        }
    }



    componentWillUnmount() {
        clearInterval(this.interval);
    }

    setZoomOut() {
        if (window.electron) {
            // //console.log('called Zoom out')
            window.electron.ipcRenderer.send('zoom-out', ['ping'])
        }
    }


    startScanning = () => {
        if (window.AndroidClicker) {
            //console.log('scanning Started.......from Classwork experience')
            window.AndroidClicker.startScanning(); // Calls native Android function
        } else {
            //console.log("AndroidClicker interface not found!");
        }
    };

    callInInterval() {
        // this.interval = setInterval(() => {
        //     this.startScanning()
        // }, 2 * 60 * 1000);
    }

    toggleLayoutBar() {
        // //console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)

        if (window.electron) {
            // //console.log('called Zoom out')
            window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
        }

        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }


    backhandler = () => {
        // BackHandler.removeEventListener('hardwareBackPress', this.backhandler);
        return true
    }

    // _handleAppStateChange = (state) => {
    //     if ((state == constants.APP_STATE_BACKGROUND && Platform.OS == 'android') || (state == constants.APP_STATE_IN_ACTIVE && Platform.OS == 'ios')) {
    //         HomeworkShared.setHomeworkPageStatus(true)
    //     }
    // }

    getAssessmentContent = (callback) => {

        let payload = {
            nodeId: this.params.nodeId,
            homeworkId: this.params.homeworkId
        };

        let userIds = []

        this.props.studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)
            }
        })

        if (userIds.length) {
            payload.userIds = userIds.join(',')
        }

        HomeworkForClickerPracticeApi.getStandardHomeworkClickerPracticeAssessment(payload).then((data) => {
            callback && callback(null, data);
        }).catch(err => {
            callback && callback(err, null);
        })
    }

    setQuestion = (data) => {

        // //console.log(CommonUtils.shuffleArray(JSON.parse(JSON.stringify(data.content))))

        //console.log(JSON.parse(JSON.stringify(data.content)))


        this.totalElos = data.totalElos;
        this.eloPosition = data.eloPosition;

        // this.setState({ questions: CommonUtils.shuffleArray(JSON.parse(JSON.stringify(data.content))), index: 0, currentQuestionNumber: data.completedQuestionNumber + 1, totalQuestions: this.params.homework.approximateQuestions });

        this.setState({
            questions: JSON.parse(JSON.stringify(data.content)),
            index: 0,
            currentIndex: 0,
            currentQuestionNumber: data.completedQuestionNumber + 1 <= this.params.homework.approximateQuestions ? data.completedQuestionNumber + 1 : data.completedQuestionNumber,
            totalQuestions: this.params.homework.approximateQuestions
        });

        if (data.resume && data.resume.contentId) {

            let resumeIndex = 0;

            for (let i = 0; i < data.content.length; i++) {
                if (data.content[i].id === data.resume.contentId) {
                    resumeIndex = i;
                    break;
                }
            }

            //console.log(resumeIndex)

            if (data.content[resumeIndex].details.content.isMultiStep) {

                // //console.log(data.content[resumeIndex].answer)

                let stepIndex = 0

                if (data.content[resumeIndex].details.content.steps &&
                    data.content[resumeIndex].details.content.steps.length &&
                    data.content[resumeIndex].answer &&
                    data.content[resumeIndex].answer.answer &&
                    data.content[resumeIndex].answer.answer.steps.length) {
                    stepIndex = data.content[resumeIndex].details.content.steps.length <= data.content[resumeIndex].answer.answer.steps.length ? data.content[resumeIndex].answer.answer.steps.length - 1 : data.content[resumeIndex].answer.answer.steps.length
                }

                this.answer = data.content[resumeIndex].answer

                this.setState({
                    index: resumeIndex,
                    currentIndex: resumeIndex,
                    currentStepIndex: stepIndex,
                    stepIndex: stepIndex,
                    showMainQuestion: stepIndex ? true : false,
                    currentQuestionNumber: stepIndex ? this.state.currentQuestionNumber - 1 : this.state.currentQuestionNumber,
                    // stepIndex: data.content[resumeIndex].answer &&
                    //     data.content[resumeIndex].answer.steps.length ? data.content[resumeIndex].answer.steps.length : 0,
                    questionLoading: false,
                    isResume: true
                }, () => {
                    this.setState({ questionLoading: true })
                });

            } else {
                this.setState({ index: resumeIndex, currentIndex: resumeIndex, isResume: true, questionLoading: false }, () => {
                    this.setState({ questionLoading: true })
                });
            }
        }
    }

    reset = () => {
        this.setState({
            questions: [],
            answers: [],
            learningElos: [],
            index: 0
        });
    }

    next() {

        // //console.log(this.answer)

        this.answer = this.questionComponent && this.questionComponent.getAnswer();
        this.optionsHash = this.questionComponent && this.questionComponent.getOptionsInfo()
        this.question = this.state.questions[this.state.index].details;
        console.log('Index in Next', this.state.index, this.state.currentIndex, this.state.studentList)
        // this.state.questions[this.state.index]['answer'] = this.answer
        console.log(this.state.questions, this.answer, this.optionsHash, this.state.showPreviousQuestion)
        // //console.log(this.optionsHash)


        if (this.answer != null && this.state.index >= this.state.currentIndex && !this.state.showPreviousQuestion) {

            let questions = this.state.questions
            questions[this.state.index]['answer'] = this.answer
            // this.state.questions[this.state.index]['answer'] = this.answer
            questions[this.state.index]['optionsHash'] = this.optionsHash
            this.setState({ questions, showPreviousQuestion: false, questionLoading: false, isResume: false })

            if (this.question.content.isMultiStep) {

                //console.log('inside multi step')

                let ques = this.question.content.steps[this.state.stepIndex];
                let ans = this.answer.answer.steps[this.state.stepIndex];

                this.setState({ disableNext: true })

                this.setState({ disableNext: false })

                // if (res.data.isCorrect) {
                if (this.question.content.isMultiStep && this.state.stepIndex === this.question.content.steps.length - 1) {

                    if (this.state.questions.length > this.state.index + 1) {
                        this.updateUserActivity(this.state.questions[this.state.index], this.state.questions[this.state.index + 1], this.answer, null, this.optionsHash, (err, updatedResponse) => {
                            if (err) {
                                return
                            }
                            //console.log('All Steps Completed', updatedResponse)
                            this.multiStepTimeListHash = updatedResponse.data.timeListHash
                            questions[this.state.index]['multiStepTimeListHash'] = updatedResponse.data.timeListHash
                            questions[this.state.index]['caseStudySkillHash'] = updatedResponse.data.caseStudySkillHash

                            this.setState({ questions })
                            this.ShowCorrectIncorrectModel(false);
                        })

                    } else {

                        // if (this.state.questions[this.state.index] && this.answer) {
                        //     //console.log('inside---111')
                        //     if (this.state.questions[this.state.index].id != this.answer.id) {
                        //         //console.log('inside---112')
                        //         return
                        //     }
                        // }

                        // //console.log('elo end reached to update in next function')

                        this.updateUserActivity(this.state.questions[this.state.index], null, this.answer, null, this.optionsHash, (err, updatedResponse) => {

                            if (err) {
                                return;
                            }

                            this.multiStepTimeListHash = updatedResponse.data.timeListHash
                            questions[this.state.index]['multiStepTimeListHash'] = updatedResponse.data.timeListHash
                            questions[this.state.index]['caseStudySkillHash'] = updatedResponse.data.caseStudySkillHash
                            this.setState({ questions })
                            this.assessNode((err, assessdResponse) => {
                                if (err) {
                                    this.setState({ disableNext: false })
                                    return;
                                }

                                let { currentNode, nextNode, isLastNode } = this.getNodeMetaInfo()

                                if (!isLastNode && nextNode) {

                                } else {
                                    //console.log("show success failure screen")
                                    // this.showSuccessFailureScreen(res);
                                    this.assessedResponse = assessdResponse
                                }


                                // if (res.data.isCorrect)
                                //     this.ShowCorrectIncorrectModel(true);
                                // else
                                this.ShowCorrectIncorrectModel(false);

                            })
                        })
                    }

                } else {
                    // //console.log(this.answer)
                    this.updateUserActivity(this.state.questions[this.state.index], this.state.questions[this.state.index], this.answer, null, this.optionsHash, (err, res) => {
                        if (err) {
                            return
                        }
                        this.nextContinue(this.question, this.answer, false);
                    })
                }
                // this.ShowCorrectIncorrectModel(false);


            } else {

                this.setState({ disableNext: true })
                // this.validateAnswer(this.question, this.answer, (err, res) => {

                //     if (err) {
                //         this.setState({ disableNext: false })
                //         return;
                //     }
                this.setState({ disableNext: false })

                ////console.log(res)

                if (this.state.questions.length > this.state.index + 1) {

                    if (this.state.questions[this.state.index] && this.answer) {
                        if (this.state.questions[this.state.index].id != this.answer.id) {
                            return
                        }
                    }

                    this.updateUserActivity(this.state.questions[this.state.index],
                        this.state.questions[this.state.index + 1], this.answer, null, this.optionsHash, (err, updatedRes) => {
                            if (err) {
                                return
                            }
                            // if (res.data.isCorrect)
                            //     this.ShowCorrectIncorrectModel(true);
                            // else
                            this.ShowCorrectIncorrectModel(false);

                        })
                } else {

                    if (this.state.questions[this.state.index] && this.answer) {
                        //console.log('inside---111')
                        if (this.state.questions[this.state.index].id != this.answer.id) {
                            //console.log('inside---112')
                            return
                        }
                    }

                    this.updateUserActivity(this.state.questions[this.state.index], null, this.answer, null, this.optionsHash, (err, updatedRes) => {

                        if (err) {
                            return;
                        }

                        this.assessNode((err, assessdResponse) => {
                            if (err) {
                                this.setState({ disableNext: false })
                                return;
                            }


                            let { currentNode, nextNode, isLastNode } = this.getNodeMetaInfo()

                            if (!isLastNode && nextNode) {

                            } else {
                                //console.log("show success failure screen..............")
                                // this.showSuccessFailureScreen(res);
                                this.assessedResponse = assessdResponse
                            }

                            // if (res.data.isCorrect)
                            //     this.ShowCorrectIncorrectModel(true);
                            // else
                            this.ShowCorrectIncorrectModel(false);

                        })
                    })
                }
                // });
            }
        } else if (this.state.showPreviousQuestion && this.state.index <= this.state.currentIndex) {
            // To See the Prvious Question
            this.answer = this.state.questions[this.state.index].answer
            this.optionsHash = this.state.questions[this.state.index].optionsHash
            console.log('Previous Questions Student Response Screen', this.state.index, this.state.currentIndex, this.answer, this.optionsHash)

            if (this.question.content.isMultiStep) {
                this.multiStepTimeListHash = this.state.questions[this.state.index].multiStepTimeListHash
                if (this.question.content.steps.length - 1 === this.state.stepIndex) {
                    if (this.state.stepIndex)
                        this.resetStepIndex();

                    this.ShowCorrectIncorrectModel(false);
                } else {

                    this.nextContinue(this.question, this.answer, false)
                }
            } else {
                this.ShowCorrectIncorrectModel(false);
            }

            // this.toggleInvalidAnswerModal(true);
        } else {
            this.setState({ showPreviousQuestion: false })
            //console.log('Correct incorrect modal', this.state.index, this.state.currentIndex, this.answer)
            this.toggleInvalidAnswerModal(true);
        }
    }

    nextQuestionOnCorrectInCorrectAnswer() {

        this.setState({ showCorrectIncorrectModal: false, isReadOnly: false, questionLoading: false });

        if (this.question.content.isMultiStep) {
            ////console.log('continue 200', this.question)
            if (this.isCorrect)
                this.nextContinue(this.question, this.answer, true);
            else
                this.nextContinue(this.question, this.answer, true);

        } else {
            ////console.log('normal next continue called...')
            this.nextContinue(this.question, this.answer);
        }

    }

    nextContinue = (question, answer, branchQuesExit) => {


        if (this.state.questions.length > this.state.index) {

            // let questions = this.state.questions
            // questions[this.state.index]['answer'] = this.answer
            // // this.state.questions[this.state.index]['answer'] = this.answer
            // questions[this.state.index]['optionsHash'] = this.optionsHash
            // this.setState({ questions })
        }


        if (question.content.isMultiStep && question.content.steps.length - 1 > this.state.stepIndex && !branchQuesExit) { /** If question is multi step  */

            let studentList = this.props.studentList

            studentList.forEach(item => {
                item.receivedAnswer = false
                item.isCorrect = null
                item.value = -1
                item.answerId = ''
            })

            if (this.state.stepIndex + 1 === this.state.currentStepIndex && this.state.index === this.state.currentIndex) {
                this.setState({ showPreviousQuestion: false, showMainQuestion: true })
            }


            this.setState({ stepIndex: this.state.stepIndex + 1, studentList, questionLoading: false }, () => {
                this.setState({ questionLoading: true })
            });


        } else { /** If it normal question */

            console.log("inside normal next question", this.state.questions.length, this.state.index)

            if (this.state.stepIndex)
                this.resetStepIndex();

            if (this.state.questions.length > this.state.index + 1) {
                // if (this.state.questions[this.state.index] && answer) {
                //     if (this.state.questions[this.state.index].id != answer.id) {
                //         return
                //     }
                // }
                //console.log('inside Next Question')
                // this.updateUserActivity(this.state.questions[this.state.index], this.state.questions[this.state.index + 1], answer, null, (err, res) => {
                //     if (err) {
                //         return
                //     }

                let studentList = this.props.studentList

                studentList.forEach(item => {
                    item.receivedAnswer = false
                    item.value = -1
                    item.answerId = ''
                })

                //console.log(studentList)

                this.setState({
                    index: this.state.index + 1,
                    showPreviousQuestion: this.state.index + 1 === this.state.currentIndex ? false : this.state.index < this.state.currentIndex ? true : this.state.showPreviousQuestion ? true : false,
                    currentQuestionNumber: this.state.currentQuestionNumber + 1,
                    studentList, questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
                // });
            }
            else { /** If end of the elo reached */

                console.log("ELO End Reached")


                // if (this.state.questions[this.state.index] && answer) {
                //     //console.log('inside---111')
                //     if (this.state.questions[this.state.index].id != answer.id) {
                //         //console.log('inside---112')
                //         return
                //     }
                // }

                // this.updateUserActivity(this.state.questions[this.state.index], null, answer, null, (err, res) => {

                //     if (err) {
                //         return;
                //     }

                this.setState({ disableNext: true })
                // this.assessNode((err, res) => {

                //     if (err) {
                //         this.setState({ disableNext: false })
                //         return;
                //     }

                let { currentNode, nextNode, isLastNode } = this.getNodeMetaInfo()

                //console.log("isLastNode", isLastNode)
                //console.log("Next Node", nextNode)

                if (!isLastNode && nextNode) {

                    this.params.nodeId = nextNode.id

                    this.getAssessmentContent((err, data) => {

                        if (err) {
                            this.setState({ disableNext: false })
                            return;
                        }

                        let studentList = this.props.studentList

                        studentList.forEach(item => {
                            item.receivedAnswer = false
                            item.value = -1
                            item.answerId = ''
                        })

                        this.setState({
                            disableNext: false,
                            // questions: data.content,
                            // index: 0,
                            questions: this.state.questions.concat(data.content),
                            index: this.state.index + 1,
                            showPreviousQuestion: this.state.index + 1 === this.state.currentIndex ? false : this.state.index < this.state.currentIndex ? true : this.state.showPreviousQuestion ? true : false,
                            // currentIndex: this.state.currentIndex + 1,
                            stepIndex: 0,
                            questionLoading: false,
                            currentQuestionNumber: data.completedQuestionNumber + 1,
                            studentList
                        }, () => {
                            this.setState({ questionLoading: true })
                        });
                    });
                } else {
                    //console.log("show success failure screen...end next button pressed")
                    // this.showSuccessFailureScreen(this.assessedResponse);
                    this.goToPracticeList()
                }
                // });

                // });
            }
        }
    }

    assessNode(callback) {

        let payload = {
            nodeId: this.params.nodeId,
            homeworkId: this.params.homeworkId
        }

        HomeworkForClickerPracticeApi.assessStandaredHomeworkClickerPracticeNode(payload).then((res) => {

            if (callback)
                callback(null, res);

        }).catch(err => {
            if (callback)
                callback(err, null);
        })

    }

    updateUserActivity(presentContent, resumeContent, answer, isReEnforcementCompleted, optionsHash, callback) {

        let payload = {
            nodeId: this.params.nodeId,
            homeworkId: this.params.homeworkId
        };

        if (presentContent)
            payload.eloActivity = { contentId: presentContent.id, answer: answer, eloId: presentContent.eloId, optionsHash }

        if (resumeContent)
            payload.resume = { contentId: resumeContent.id, eloId: resumeContent.eloId };


        if (isReEnforcementCompleted)
            payload.isReEnforcementCompleted = true;


        let userIds = []

        this.props.studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)
            }
        })

        if (userIds.length) {
            payload.userIds = userIds.join(',')
        }

        // console.log(this.state.studentList, this.props.studentList)

        payload.studentList = this.state.studentList

        HomeworkForClickerPracticeApi.updateUserHomeworkClickerPracticeActivity(payload).then((res) => {
            if (callback)
                callback(null, res);
        }).catch(err => {

            if (callback)
                callback(err, null);

        })
    }

    showSuccessFailureScreen = (data) => {

        // //console.log(data)

        // this.layoutShared.toggleSidebar(true)

        this.setState({ disableNext: false })

        this.successFailureScreenData = {
            concepts: this.params.concepts,
            chapterTitle: this.params.title,
            homeworkId: this.params.homeworkId,
            cleared: data.data.cleared,
            notCleared: data.data.notCleared,
            progress: data.data.progress,
            chapterImageUrl: this.params.chapterImageUrl
        }

        this.props.delegate && this.props.delegate.showAssessmentEndScreen && this.props.delegate.showAssessmentEndScreen({
            data: data.data
        })
    }

    goToPracticeList() {
        this.props.delegate && this.props.delegate.showPracticeListScreen && this.props.delegate.showPracticeListScreen()
    }

    getCurrentNode = () => {
        let nodes = this.params.nodes;
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].id == this.params.nodeId) {
                return nodes[i];
            }
        }
    }

    previous(isReadOnly = false) {

        console.log('previous Pressed', isReadOnly)
        let question = this.state.questions[this.state.index].details;
        let studentList = this.props.studentList

        studentList.forEach(item => {
            item.receivedAnswer = false
            item.value = -1
            item.answerId = ''
        })

        this.setState({ studentList })


        if (isReadOnly === true) {
            console.log('inside readonly')
            if (this.state.stepIndex) {
                this.resetStepIndex()
            }

            if (!this.state.showPreviousQuestion) {
                this.setState({
                    currentIndex: this.state.index + 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            } else {
                this.setState({
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            }
            return
        }


        if (question.content.isMultiStep && this.state.stepIndex !== 0) {
            //console.log("inside Previous Step", this.state.stepIndex)

            if (!this.state.showPreviousQuestion) {
                this.setState({
                    currentStepIndex: this.state.stepIndex,
                    stepIndex: this.state.stepIndex - 1,
                    currentIndex: this.state.index,
                    showMainQuestion: false,
                    // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            } else {
                this.setState({
                    stepIndex: this.state.stepIndex - 1,
                    showMainQuestion: this.state.stepIndex - 1 === 0 ? false : true,
                    // index: this.state.index - 1,
                    // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            }

        } else if (question.content.isMultiStep && this.state.stepIndex === 0 && !this.state.showMainQuestion) {
            this.setState({
                stepIndex: 0,
                showMainQuestion: true,
                // index: this.state.index - 1,
                // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                showPreviousQuestion: true,
                questionLoading: false
            }, () => {
                this.setState({ questionLoading: true })
            });
        }
        // else if (question.content.isMultiStep && this.state.stepIndex === 0 && this.state.showMainQuestion
        //     && !this.state.questions[this.state.index].answer
        // ) {
        //     this.setState({
        //         stepIndex: 0,
        //         showMainQuestion: true,
        //         // index: this.state.index - 1,
        //         // currentQuestionNumber: this.state.currentQuestionNumber - 1,
        //         showPreviousQuestion: true,
        //         questionLoading: false
        //     }, () => {
        //         this.setState({ questionLoading: true })
        //     });
        // }
        else {

            if (this.state.index != 0) {
                console.log('inside Previous', this.state.index)


                if (this.state.stepIndex) {
                    this.resetStepIndex()
                }

                if (!this.state.showPreviousQuestion) {
                    this.setState({
                        currentIndex: this.state.index,
                        index: this.state.index - 1,
                        currentQuestionNumber: this.state.currentQuestionNumber - 1,
                        showPreviousQuestion: true,
                        questionLoading: false
                    }, () => {
                        this.setState({ questionLoading: true })
                    });
                } else {
                    this.setState({
                        index: this.state.index - 1,
                        currentQuestionNumber: this.state.currentQuestionNumber - 1,
                        showPreviousQuestion: true,
                        questionLoading: false
                    }, () => {
                        this.setState({ questionLoading: true })
                    });
                }
            }
        }
    }

    resetStepIndex = () => {
        this.setState({ stepIndex: 0 });
    }

    validateAnswer = (question, answer, callback) => {

        let payload = { question, answer };

        HomeworkForClickerPracticeApi.validateAnswerForClickerPractice(payload).then((res) => {
            callback(null, res);
        }).catch(err => {
            callback(err, null);
        })
    }

    goToChapterList = () => {
        this.props.navigation.navigate('Chapters')
    }

    goToLateralMenu = () => {
        this.props.navigation.navigate('LateralMenu')
    }

    toggleInvalidAnswerModal = (value) => {
        this.setState({ showInvalidAnswerModal: value, questionLoading: true }, () => {
            this.setState({ questionLoading: true })
        });
    }

    ShowCorrectIncorrectModel = (isCorrect) => {
        this.isCorrect = isCorrect;
        this.setState({ showCorrectIncorrectModal: true, questionLoading: false }, () => {
            this.setState({ questionLoading: true })
        })
    }

    hideCorrectIncorrectModal() {
        this.setState({ showCorrectIncorrectModal: false });
    }

    onOk = () => {
        this.toggleInvalidAnswerModal(false);
    }

    getNodeMetaInfo = () => {

        let currentNodeIndex = null

        let nodes = this.params.nodes;

        ////console.log(nodes)

        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].id == this.params.nodeId) {
                currentNodeIndex = i
                break;
            }
        }
        return { currentNode: nodes[currentNodeIndex], nextNode: nodes[currentNodeIndex + 1], isLastNode: nodes.length - 1 <= currentNodeIndex }
    }

    onPressResumeTimePopupContinue = () => {
        this.setState({ showResumeTimePopup: false })
    }

    showTimerPauseToast = () => {
        let minutes = this.getRemainingTime()
        let message = CommonUtils.simpleTemplateEngine(this.staticText.timerPauseText, { time: minutes })
        this.setState({ toastText: message }, () => {
            this.showResumeTimerPopUp()
        })
    }

    getRemainingTime = () => {
        if (this.landingScreenInstance) {
            this.remainingTime = this.landingScreenInstance.getRemainingAppTime()
            return this.remainingTime ? Math.ceil(this.remainingTime / 60) : 0
        }

        return 0
    }

    showTimerResumeText = () => {
        let minutes = this.getRemainingTime()
        let message = CommonUtils.simpleTemplateEngine(this.staticText.timerResumeText, { time: minutes })
        this.setState({ toastText: message }, () => {
            this.showResumeTimerPopUp()
        })
    }

    showResumeTimerPopUp = () => {
        this.setState({ showResumeTimePopup: true }, () => {
            // setTimeout(() => this.setState({ showResumeTimePopup: false }), 3000)
        })
    }





    render() {
        ////console.log(this.state.questionNumberIndex)
        //console.log(this.state.questions, this.state.index)

        return (
            <div className="standard-homework-experience-for-clicker">
                {!this.state.showSuccessFailureScreen ?
                    <>
                        {
                            this.state.learningElos.length === 0 && this.state.questions.length > 0 &&
                            <div>
                                {
                                    this.state.questionLoading ?
                                        <>
                                            {/* <AssessmentHeader questionCount={true}
                                                currentQuestionNumber={this.state.currentQuestionNumber}
                                                totalQuestions={this.state.totalQuestions}
                                                title={this.params.title ? this.params.title : ''}
                                                
                                                categoryThemeId={1}>
                                            </AssessmentHeader> */}
                                            <div className="ml-5 mt-3">
                                                {
                                                    this.state.questions && this.state.questions.length > 0 &&
                                                    <div>
                                                        <ClickerPracticeConText.Provider value={{ index: this.state.index, disableNextStandardHomework: this.state.disableNext, showAlphabetForHomeworkAssessment: true }}>
                                                            <Question delegate={this} ref={(ref) => { this.questionComponent = ref }}
                                                                totalQuestions={this.state.totalQuestions}
                                                                questions={this.state.questions}
                                                                activePage={this.state.currentQuestionNumber}
                                                                studentList={this.state.studentList}
                                                                answer={this.state.questions[this.state.index].answer}
                                                                content={this.state.questions[this.state.index].details}
                                                                stepIndex={this.state.stepIndex}
                                                                showHint={this.state.showHint}
                                                                showSolvedExamplesModal={this.state.showSolvedExamplesModal}
                                                                showInvalidAnswerModal={this.state.showInvalidAnswerModal}
                                                                showCorrectIncorrectModal={this.state.showCorrectIncorrectModal}
                                                                isAnswerCorrect={this.isCorrect}
                                                                userAnswerForReadOnly={this.answer ? this.answer : {}}
                                                                optionsHashForReadOnly={this.optionsHash ? this.optionsHash : {}}
                                                                homeworkId={this.params.homeworkId}
                                                                showTimer={this.params.homework.showTimer}
                                                                showLeaderboard={this.params.homework.showLeaderboard}
                                                                leaderboardLimit={this.params.homework.leaderboardLimit}
                                                                classText = {this.params.homework.class}
                                                                // categoryThemeId={this.state.questions[this.state.index].categoryThemeId}
                                                                categoryThemeId={1}
                                                                multiStepTimeListHash={this.multiStepTimeListHash}
                                                                showPreviousQuestion={(this.state.index < this.state.currentIndex) ? true : this.state.showPreviousQuestion ? true : false}
                                                                showMainQuestion={this.state.showMainQuestion} // to Show the Multi Step Main Question in index 0
                                                                isResume={this.state.isResume}
                                                            ></Question>
                                                        </ClickerPracticeConText.Provider>
                                                    </div>
                                                }
                                            </div>

                                        </>

                                        :
                                        // <></>
                                        <Loading />
                                }

                            </div>
                        }
                    </>
                    :

                    <SuccessFailureScreen
                        data={this.successFailureScreenData}
                        navigation={this.props.navigation}
                        categoryThemeId={this.params.categoryThemeId}
                        conceptsCovered={this.params.conceptsCovered}
                        homework={this.params.homework}
                        delegate={this.props.delegate} />
                    // this.params.typeOfSchoolwork === 'CLASSWORK' ? <div className="margin-for-concept-list">

                    //     <ConceptList
                    //         meta={this.successFailureScreenData}
                    //         conceptsCovered={this.params.conceptsCovered}
                    //         homework={this.params.homework}
                    //         delegate={this.props.delegate} />
                    // </div>
                    // :
                    // <div className="margin-for-concept-list">

                    //     <HomeworkConceptList meta={this.successFailureScreenData} delegate={this.props.delegate} />
                    // </div>
                }

                {/* {this.state.showResumeTimePopup ? <TimerResumePopup modal={true} onPressContinue={this.onPressResumeTimePopupContinue} message={this.state.toastText} categoryThemeId={this.params.categoryThemeId} /> : <></>} */}

                {/* {this.state.showResumeTimePopup ? <TimerToaster message={this.state.toastText} /> : <></>} */}
            </div>


        )
    }
}